import { render, staticRenderFns } from "./Header-Option.vue?vue&type=template&id=0b1f2fda&"
import script from "./Header-Option.vue?vue&type=script&lang=js&"
export * from "./Header-Option.vue?vue&type=script&lang=js&"
import style0 from "./Header-Option.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports